var _path, _ellipse, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconError01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 62 58"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CCC",
  strokeMiterlimit: 10,
  strokeWidth: 6.6,
  d: "M59 23.259c-7.716-6.129-17.43-9.773-27.981-9.773S10.725 17.149 3 23.296M49.788 32.774a30.92 30.92 0 0 0-18.76-6.294 30.94 30.94 0 0 0-18.825 6.35M41.267 43.247c-2.942-2.344-6.467-3.709-10.247-3.709s-7.334 1.377-10.287 3.734"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.828,
  cy: 52.461,
  fill: "#CCC",
  rx: 3.435,
  ry: 3.411
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m12.717 8.002 4.896-3.464 32.626 45.46-4.896 3.464z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8.518 7.297 18.313.368l36.124 50.335-9.794 6.929zm4.199.705 32.626 45.46 4.896-3.464-32.626-45.46z",
  clipRule: "evenodd"
})));
export default SvgIconError01;